import React from 'react'
import { ConfirmationRoleAction } from '../../../legacy-design-system/action'
import { RenderDialogProps } from '../../../legacy-design-system/action/confirmation-action'
import { ModifyDiagnosticCollectionDialog } from '../../server-settings/diagnostic-dialog'
import { Role } from '@contrast-security-inc/base-types'
import { PureQueryOptions } from 'apollo-client'
import { Placement } from '../../../legacy-design-system/popper'
import {
  IconDiagnostic,
  theme
} from '@contrast-security-inc/design-system-foundations'
import { AgentFeature } from '../../agent-features'
import { css } from '@emotion/css'
import { ConfirmationRoleActionProps } from '../../../legacy-design-system/action/confirmation-role-action'

interface Server {
  id: string
  diagnosticCollectionEnabled: boolean
}

const enabledCss = css`
  :hover:enabled svg,
  :hover:focus-visible svg,
  svg {
    fill: ${theme.color.teal50};
    stroke: ${theme.color.teal50};
  }
`

// exported for testing
export function getConfirmationProps(
  organizationRole: Role,
  diagnosticEnabled: boolean
) {
  const tooltip = diagnosticEnabled
    ? 'title_servers_enableDiagnosticCollection'
    : 'title_servers_disableDiagnosticCollection'
  const requiredRole: Role = 'ADMIN'
  return {
    isActionValid: true,
    requiredRole,
    className: diagnosticEnabled ? enabledCss : undefined,
    icon: IconDiagnostic,
    iconTooltipMessage: {
      id: tooltip,
      defaultMessage: 'Diagnostic Collection'
    },
    role: organizationRole,
    iconTooltipPlacement: 'top' as Placement
  }
}

interface SingleActionProps extends Pick<ConfirmationRoleActionProps, 'size'> {
  readonly server: Server
  readonly organizationID: string
  readonly organizationRole: Role
  readonly refetchQueries: PureQueryOptions[]
  readonly refresh: () => Promise<any>
  readonly isFreemium: boolean
  readonly diagnosticFeatureEnabled: boolean

  /**
   * True if the current user is a Protect user
   */
  readonly protect: boolean

  /**
   * The current organization's available agent features
   */
  readonly agentFeatures: AgentFeature[]
}

export function ModifyDiagnosticCollectionAction({
  server,
  organizationID,
  organizationRole,
  refetchQueries,
  refresh,
  agentFeatures,
  protect,
  isFreemium,
  diagnosticFeatureEnabled,
  size
}: SingleActionProps) {
  return diagnosticFeatureEnabled ? (
    // @ts-ignore
    <ConfirmationRoleAction
      size={size}
      {...getConfirmationProps(
        organizationRole,
        server.diagnosticCollectionEnabled
      )}
      renderDialog={({ isOpen, closeDialog }: RenderDialogProps) => {
        return (
          <ModifyDiagnosticCollectionDialog
            organizationID={organizationID}
            serverID={server.id}
            closeDialog={closeDialog}
            isOpen={isOpen}
            refetchQueries={refetchQueries}
            refresh={refresh}
            agentFeatures={agentFeatures}
            protect={protect}
            isFreemium={isFreemium}
          />
        )
      }}
    />
  ) : null
}
